import { createI18n, type Composer } from 'vue-i18n'
import ptBR from './pt-BR'
import en from './en'

const savedLocale = localStorage.getItem('locale') || 'pt-BR'

const i18n = createI18n({
  legacy: false,
  locale: savedLocale,
  fallbackLocale: 'pt-BR',
  messages: {
    'pt-BR': ptBR,
    'en': en,
  },
})

export default i18n

export function setLocale(newLocale: string) {
  const global = i18n.global as unknown as Composer
  global.locale.value = newLocale
  localStorage.setItem('locale', newLocale)
  document.documentElement.setAttribute('lang', newLocale)
}
